import type {ReactElement} from 'react';
import React from 'react';
import {ControlledList} from '@Components/controlled-list';
import {CONTROLLED_LIST_ITEM_TYPE} from '@Components/controlled-list/controlled-list.types';
import {onOpenMenuModal, onOpenScheduleModal, onOpenTableModal} from '@Components/poster-editor/library/poster-editor-open-modals';
import {ThumbnailType} from '@Components/thumbnail/thumbnail.types';
import {AddItemThumbnail} from '@Components/poster-editor/components/poster-add-item-bar/components/add-item-thumbnail';
import {addTabsToPoster} from '@PosterWhiteboard/items/tabs-item/tabs-item.class';
import type {AddItemDropdownProps} from '@Components/poster-editor/components/poster-add-item-bar/poster-add-item-bar.types';
import {noop} from '@Utils/general.util';

interface LayoutDropdownListProps extends AddItemDropdownProps {}

export function LayoutDropdownList({className = '', onOpenModal = noop}: LayoutDropdownListProps): ReactElement | null {
  const getOptionsForLayout = (): ReactElement => {
    return (
      <ControlledList
        className={`spacing-m-0 ${className}`}
        items={[
          {
            id: 'add-schedule-layout',
            type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_2,
            text: window.i18next.t('pmwjs_schedule'),
            subText: window.i18next.t('pmwjs_add_schedule_description'),
            onClick: (): void => {
              onOpenModal();
              onOpenScheduleModal();
            },
            thumbnail: {
              type: ThumbnailType.CUSTOM,
              content: <AddItemThumbnail icon="icon-calendar" />,
            },
          },
          {
            id: 'add-menu',
            type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_2,
            text: window.i18next.t('pmwjs_menu_capitalize'),
            subText: window.i18next.t('pmwjs_add_menu_option_description'),
            onClick: (): void => {
              onOpenModal();
              onOpenMenuModal();
            },
            thumbnail: {
              type: ThumbnailType.CUSTOM,
              content: <AddItemThumbnail icon="icon-food-menu" />,
            },
          },
          {
            id: 'add-table-layout',
            type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_2,
            text: window.i18next.t('pmwjs_table'),
            subText: window.i18next.t('pmwjs_add_a_table'),
            onClick: (): void => {
              onOpenModal();
              onOpenTableModal();
            },
            thumbnail: {
              type: ThumbnailType.CUSTOM,
              content: <AddItemThumbnail icon="icon-table" />,
            },
          },
          {
            id: 'add-tear-off-tabs',
            type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_2,
            text: window.i18next.t('pmwjs_tear_off_tabs'),
            subText: window.i18next.t('pmwjs_add_tear_off_tabs_description'),
            onClick: addTabsToPoster,
            thumbnail: {
              type: ThumbnailType.CUSTOM,
              content: <AddItemThumbnail icon="icon-tear-off-tabs" />,
            },
          },
        ]}
      />
    );
  };

  return getOptionsForLayout();
}
